/* eslint-disable default-case */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { SignaturePlanTypes, PlansState } from './types';

const INITIAL_STATE: PlansState = {
  plans: {
    planos: {
      invoice: {},
      card: {},
    },
    plans_all: {
      semestral: {
        valor_base: 0,
        valor_cartao: 0,
        parcelas: '',
      },
      anual: {
        valor_base: 0,
        valor_cartao: 0,
        parcelas: '',
      },
      bienal: {
        valor_base: 0,
        valor_cartao: 0,
        parcelas: '',
      },
    },
  },
  current_layout: {
    layout: 'premium',
    plano_id: 5,
    plano: 'Anual',
    renewal: false,
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<PlansState> = (
  state = INITIAL_STATE,
  { type, result, layout, plano_id, plano, renewal },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case SignaturePlanTypes.GET_PLAN_REQUEST:
        draft.current_layout = {
          layout,
          plano_id,
          plano,
          renewal,
        };
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case SignaturePlanTypes.GET_PLAN_SUCCESS:
        draft.current_layout = {
          layout,
          plano_id,
          plano,
          renewal,
        };
        draft.plans.planos = result.data.packages;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case SignaturePlanTypes.GET_PLAN_FAILURE:
        draft.current_layout = INITIAL_STATE.current_layout;
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case SignaturePlanTypes.SIMULATE_ALL_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case SignaturePlanTypes.SIMULATE_ALL_SUCCESS:
        draft.plans.plans_all = result?.data;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case SignaturePlanTypes.SIMULATE_ALL_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      default:
    }
  });
};
export default reducer;
